import Form     from 'scripts/poppet/form';
import template from 'templates/unitAlarmForm.jst.html';

const selectors = {
	inputAlarm: '[data-input=alarm-message]',
};

/**
 * defa.views.UnitAlarmForm
 * A view for changing a units general alarm input.
 * @version 1.0.0
 */
const UnitAlarmForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	ui: {
		alarm: selectors.inputAlarm,
	},
	
	templateContext: function(){
		return{
			message : this.model.get('gpaiAlias') || ''
		}
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Validates the alarm message input field
	 * Triggers when the user inputs something into the  alarm message input field.
	 * @void
	 */
	validate: function(){
		let alarmMessage = this.ui.alarm.val().trim();
		return alarmMessage !== this.model.get('gpaiAlias');
	},
	
	/**
	 * Triggers when the user inputs something into the  alarm message input field.
	 * @void
	 * Runs the validate when user input something and disables/enables submit by default.
	 * In this case we want to hide the submit if validation returns false
	 */
	verifyForm: function () {
		if(!this.validate()){
			this.hideSubmit()
		}
	},
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let alarmMessage = this.ui.alarm.val().trim();
		this.model.saveAlarmMessage(alarmMessage);
		this.trigger('close');
	},
	
} );


export default UnitAlarmForm;
